var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "aiboxRef", staticClass: "yxtbiz-aibox-unify" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataLoading,
              expression: "dataLoading",
            },
          ],
          staticClass: "container",
          class: { fullscreen: _vm.isFullscreen },
        },
        [
          _c("transition", { attrs: { name: "panel-slide" } }, [
            _vm.isFullscreen
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isExpand,
                        expression: "isExpand",
                      },
                    ],
                    staticClass: "panel",
                  },
                  [
                    _c("div", { staticClass: "aibox-info" }, [
                      _c(
                        "div",
                        { staticClass: "app-info" },
                        [
                          _c("yxtf-portrait", {
                            staticClass: "portrait",
                            attrs: { size: "72px", imgUrl: _vm.appData.icon },
                          }),
                          _c("div", { staticClass: "app-name ellipsis" }, [
                            _vm._v(_vm._s(_vm.appData.appName)),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "option" }, [
                      _c("div", { staticClass: "option-left" }),
                      _c("div", { staticClass: "option-right" }, [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                _vm.isExpand = false
                              },
                            },
                          },
                          [
                            _c("yxtf-svg", {
                              staticClass:
                                "color-gray-7 hover-primary-6 hand icon",
                              attrs: {
                                width: "20px",
                                height: "20px",
                                "remote-url": _vm.ICON_PATH,
                                "icon-class": "shrink1",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isFullscreen && !_vm.isExpand,
                  expression: "isFullscreen && !isExpand",
                },
              ],
              staticClass: "expand-btn hand",
              on: {
                click: function ($event) {
                  _vm.isExpand = true
                },
              },
            },
            [
              _c("span", { staticClass: "text" }, [_vm._v("展开")]),
              _c("yxtf-svg", {
                attrs: {
                  width: "20px",
                  height: "20px",
                  "remote-url": _vm.ICON_PATH,
                  "icon-class": "expand1",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "main" },
            [
              _c("div", { staticClass: "header" }, [
                _c(
                  "div",
                  { staticClass: "left", class: { hidden: _vm.isFullscreen } },
                  [
                    _c("yxtf-portrait", {
                      attrs: { size: "36px", imgUrl: _vm.appData.icon },
                    }),
                    _c("span", { staticClass: "app-name ellipsis" }, [
                      _vm._v(_vm._s(_vm.appData.appName)),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "right" }, [
                  _c(
                    "span",
                    { on: { click: _vm.toggleFullscreen } },
                    [
                      _c("yxtf-svg", {
                        staticClass: "color-gray-7 hover-primary-6 hand icon",
                        attrs: {
                          width: _vm.iconSize,
                          height: _vm.iconSize,
                          "remote-url": _vm.iconUrl,
                          "icon-class": _vm.isFullscreen
                            ? "ai-window"
                            : "ai-screen",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { on: { click: _vm.onClose } },
                    [
                      _c("yxtf-svg", {
                        staticClass: "color-gray-7 hover-primary-6 hand icon",
                        attrs: {
                          width: _vm.iconSize,
                          height: _vm.iconSize,
                          "remote-url": _vm.iconUrl,
                          "icon-class": "ai-closed",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "yxtf-scrollbar",
                { staticClass: "chat-container", attrs: { fitHeight: "" } },
                [
                  _c("chat-box", {
                    ref: "chatBoxRef",
                    attrs: {
                      showPortrait: _vm.isFullscreen,
                      loading: _vm.qaLoading,
                      "chat-list": _vm.qaList,
                      "receive-status": _vm.receiveStatus,
                      "service-img": _vm.appData.icon,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top-option",
                        fn: function (slotProps) {
                          return [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "top-opt-btn icon-btn-status",
                                  class: {
                                    "icon-btn-active":
                                      slotProps.data.appraisement === 1,
                                    "icon-btn-disabled":
                                      slotProps.data.appraisement === 2,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onFeedbackItem(slotProps, 1)
                                    },
                                  },
                                },
                                [
                                  _c("yxtf-svg", {
                                    attrs: {
                                      width: "20px",
                                      height: "20px",
                                      "remote-url": _vm.ICON_PATH,
                                      "icon-class": slotProps.data.appraisement
                                        ? "great"
                                        : "great-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "top-opt-btn icon-btn-status",
                                  class: {
                                    "icon-btn-active":
                                      slotProps.data.appraisement === 2,
                                    "icon-btn-disabled":
                                      slotProps.data.appraisement === 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onFeedbackItem(slotProps, 2)
                                    },
                                  },
                                },
                                [
                                  _c("yxtf-svg", {
                                    attrs: {
                                      width: "20px",
                                      height: "20px",
                                      "remote-url": _vm.ICON_PATH,
                                      "icon-class": slotProps.data.appraisement
                                        ? "bad"
                                        : "bad-outline",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "option",
                        fn: function (slotProps) {
                          return [
                            _c("div", { staticClass: "option-left" }, [
                              slotProps.data.showStaffservice &&
                              slotProps.index === _vm.qaList.length - 1
                                ? _c(
                                    "div",
                                    {
                                      class: {
                                        "font-size-16": _vm.isFullscreen,
                                      },
                                    },
                                    [
                                      _c("span", { staticClass: "tips" }, [
                                        _vm._v(
                                          "抱歉，目前无法解答您的问题，您可以"
                                        ),
                                      ]),
                                      _c(
                                        "yxtf-link",
                                        {
                                          attrs: {
                                            type: "primary",
                                            underline: false,
                                          },
                                          on: { click: _vm.onStaffservice },
                                        },
                                        [_vm._v("转人工")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.apiMap.appraise &&
                                      !slotProps.data.appraisement,
                                    expression:
                                      "apiMap.appraise && !slotProps.data.appraisement",
                                  },
                                ],
                                staticClass: "option-right",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "option-btn-mini icon-btn-status",
                                    class: {
                                      "icon-btn-active":
                                        slotProps.data.appraisement === 1,
                                      "icon-btn-disabled":
                                        slotProps.data.appraisement === 2,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onFeedbackItem(slotProps, 1)
                                      },
                                    },
                                  },
                                  [
                                    _c("yxtf-svg", {
                                      attrs: {
                                        width: "20px",
                                        height: "20px",
                                        "remote-url": _vm.ICON_PATH,
                                        "icon-class": slotProps.data
                                          .appraisement
                                          ? "great"
                                          : "great-outline",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "option-btn-mini icon-btn-status",
                                    class: {
                                      "icon-btn-active":
                                        slotProps.data.appraisement === 2,
                                      "icon-btn-disabled":
                                        slotProps.data.appraisement === 1,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onFeedbackItem(slotProps, 2)
                                      },
                                    },
                                  },
                                  [
                                    _c("yxtf-svg", {
                                      attrs: {
                                        width: "20px",
                                        height: "20px",
                                        "remote-url": _vm.ICON_PATH,
                                        "icon-class": slotProps.data
                                          .appraisement
                                          ? "bad"
                                          : "bad-outline",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "staffservice",
                        fn: function (slotProps) {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      "vertical-align": "middle",
                                    },
                                  },
                                  [_vm._v("好的，请点击唤起客服")]
                                ),
                                _c(
                                  "yxtf-link",
                                  {
                                    class: { "font-size-16": _vm.isFullscreen },
                                    staticStyle: { "margin-left": "12px" },
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: { click: _vm.onStaffservice },
                                  },
                                  [_vm._v("转人工")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.processFinish,
                          expression: "processFinish",
                        },
                      ],
                      staticClass: "process-tips",
                    },
                    [
                      _c(
                        "yxt-alert",
                        { attrs: { "bg-color": "#F5F5F5", closable: false } },
                        [
                          _c(
                            "template",
                            { slot: "title" },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#595959",
                                    "margin-right": "10px",
                                  },
                                },
                                [_vm._v("流程已结束，点击按钮重新开始流程")]
                              ),
                              _c(
                                "yxt-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.resetProcess },
                                },
                                [_vm._v("重新开始")]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("chat-input", {
                ref: "chatInputRef",
                attrs: { disabled: _vm.qaLoading || _vm.processFinish },
                on: { send: _vm.onGetAnswer },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-dialog",
        {
          attrs: {
            title: "模型提示",
            visible: _vm.modelMsgDialogVisible,
            cutline: false,
            "show-close": false,
            width: "700px",
          },
        },
        [
          _c("div", [_vm._v(" " + _vm._s(_vm.modelMsg))]),
          _c(
            "template",
            { slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.assistantContinue },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }